"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Collapse_1 = tslib_1.__importDefault(require("@mui/material/Collapse"));
const MAX_HEIGHT = 100;
/**
 *
 * @category component
 */
const ShowMoreButton = ({ textShowMore, textShowLess, isActive = true, isInitialTruncated = false, maxHeight = MAX_HEIGHT, overrideExpanded, children, }) => {
    const collapseRef = (0, react_1.createRef)();
    const [isTruncated, setTruncated] = (0, react_1.useState)(isInitialTruncated);
    const [isExpanded, setExpanded] = (0, react_1.useState)(false);
    (0, react_1.useLayoutEffect)(() => {
        if (collapseRef?.current?.clientHeight >= maxHeight) {
            setTruncated(true);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (overrideExpanded !== undefined) {
            setExpanded(overrideExpanded);
        }
    }, [overrideExpanded]);
    return (react_1.default.createElement(react_1.default.Fragment, null, isActive && isTruncated ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Collapse_1.default, { in: isExpanded, collapsedSize: maxHeight }, children),
        !isExpanded && (react_1.default.createElement(Box_1.default, { sx: { position: "relative" } },
            react_1.default.createElement(Box_1.default, { sx: (theme) => ({
                    backgroundImage: `linear-gradient(to bottom, transparent, ${theme.palette.background.paper} 100%)`,
                    height: theme.spacing(10),
                    position: "absolute",
                    width: "100%",
                    bottom: 0,
                }) }))),
        react_1.default.createElement(Box_1.default, { width: "100%", display: "flex", justifyContent: "center", sx: !isExpanded ? { bgcolor: "background.paper" } : null },
            react_1.default.createElement(Button_1.default, { variant: "text", onClick: () => setExpanded(!isExpanded) }, isExpanded ? textShowLess : textShowMore)))) : (react_1.default.createElement(Box_1.default, { ref: collapseRef, sx: { overflow: "hidden" } }, children))));
};
exports.default = ShowMoreButton;
